var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAverageicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Average_icon",
    "data-name": "Average icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 38,
    height: 38,
    fill: "#898989",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16170",
    "data-name": "Group 16170",
    transform: "translate(7 7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28249",
    "data-name": "Path 28249",
    d: "M233.4,134.571a11.776,11.776,0,1,1,11.776-11.776A11.788,11.788,0,0,1,233.4,134.571m0-22.513a10.737,10.737,0,1,0,10.737,10.737A10.746,10.746,0,0,0,233.4,112.058",
    transform: "translate(-221.396 -110.795)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28250",
    "data-name": "Path 28250",
    d: "M233.12,134.519a11.963,11.963,0,1,1,4.674-.942A12.014,12.014,0,0,1,233.12,134.519Zm0-23.547a11.547,11.547,0,1,0,11.547,11.547A11.56,11.56,0,0,0,233.12,110.972Zm0,22.508a10.961,10.961,0,1,1,10.961-10.961A10.974,10.974,0,0,1,233.12,133.48Zm0-21.469a10.508,10.508,0,1,0,10.508,10.508A10.52,10.52,0,0,0,233.12,112.011Z",
    transform: "translate(-221.12 -110.519)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28251",
    "data-name": "Path 28251",
    d: "M241.951,132.219a1.131,1.131,0,1,1-1.131,1.131,1.131,1.131,0,0,1,1.131-1.131",
    transform: "translate(-233.937 -124.643)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_921",
    "data-name": "Ellipse 921",
    d: "M1.355,0A1.355,1.355,0,1,1,0,1.355,1.357,1.357,0,0,1,1.355,0Zm0,2.262a.907.907,0,1,0-.907-.907A.908.908,0,0,0,1.355,2.262Z",
    transform: "translate(6.404 9.749) rotate(-78.019)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28252",
    "data-name": "Path 28252",
    d: "M264.951,132.219a1.131,1.131,0,1,1-1.131,1.131,1.131,1.131,0,0,1,1.131-1.131",
    transform: "translate(-248.964 -124.643)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_922",
    "data-name": "Ellipse 922",
    d: "M1.355,0A1.355,1.355,0,1,1,0,1.355,1.357,1.357,0,0,1,1.355,0Zm0,2.262a.907.907,0,1,0-.907-.907A.908.908,0,0,0,1.355,2.262Z",
    transform: "translate(14.148 9.233) rotate(-61.003)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28253",
    "data-name": "Path 28253",
    d: "M249.494,155.247h-11.95a.514.514,0,1,1,0-1.028h11.915a.532.532,0,0,1,.524.514.5.5,0,0,1-.489.514",
    transform: "translate(-231.519 -139.026)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28254",
    "data-name": "Path 28254",
    d: "M249.214,155.2H237.272a.738.738,0,1,1,0-1.476h11.907a.755.755,0,0,1,.752.738A.729.729,0,0,1,249.214,155.2Zm-11.942-1.028a.29.29,0,1,0,0,.58h11.942a.277.277,0,0,0,.26-.29.308.308,0,0,0-.3-.29Z",
    transform: "translate(-231.243 -138.749)",
    fill: "#898989"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAverageicon);
export default __webpack_public_path__ + "static/media/Averageicon.6f04fa344a33e4f5ad9f19afee25cba3.svg";
export { ForwardRef as ReactComponent };